/*@ngInject*/
const OptionGroupCheckboxController = function ($rootScope, $element, localization,
                                                configurationConstant) {
    $element.addClass('optionGroupCheckbox');

    localization.getTranslationByKey('optionGroupCheckbox').then(function (translations) {
        this.init = function () {
            this.checkboxValue = this.value === 'true' || this.value === true;
        };

        this.handleChange = function () {
            $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                name: this.name,
                value: this.checkboxValue
            });
        };

        this.getClassName = function () {
            return _.lowerFirst(this.label).replace(/\s/g, '') + 'Checkbox';
        };

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupCheckboxController', OptionGroupCheckboxController);
